function toArray(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  return [];
}

function toNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function formatPagination(data, requestedPage, fallbackPerPage) {
  const pagination = data?.pagination || {};

  return {
    page: requestedPage,
    perPage: pagination.perPage || fallbackPerPage,
    totalPages: pagination.totalPages || 1,
    totalDocuments:
      pagination.total ?? pagination.totalDocuments ?? toArray(data).length,
  };
}

export function formatCrmPetUsage(data = {}) {
  return {
    summary: data.summary || null,
    daily: toArray(data.daily).sort((first, second) =>
      String(first.storeDate || "").localeCompare(String(second.storeDate || "")),
    ),
  };
}

export function formatCrmPetRecoveryKpis(data) {
  if (!data || typeof data !== "object") return null;

  return {
    attempts: toNumber(data.attempts),
    contactedAttempts: toNumber(data.contactedAttempts),
    customersWithRevenue: toNumber(data.customersWithRevenue),
    contactsMade: toNumber(data.contactsMade),
    pendingContacts: toNumber(data.pendingContacts),
    scheduledCustomers: toNumber(data.scheduledCustomers),
    purchaseCustomers: toNumber(data.purchaseCustomers),
    canceledCustomers: toNumber(data.canceledCustomers),
    rescheduledCustomers: toNumber(data.rescheduledCustomers),
    finishedCustomers: toNumber(data.finishedCustomers),
    averageContactsUntilReturn: toNumber(data.averageContactsUntilReturn),
    averageContactsUntilSchedule: toNumber(data.averageContactsUntilSchedule),
    averageContactsUntilPurchase: toNumber(data.averageContactsUntilPurchase),
    serviceRevenue: toNumber(data.serviceRevenue),
    productRevenue: toNumber(data.productRevenue),
    totalRevenue: toNumber(data.totalRevenue),
  };
}

export function formatCrmPetRecoveryAttempts(
  data = {},
  requestedPage = 0,
  perPage = 20,
) {
  return {
    results: toArray(data).map((attempt) => ({
      ...attempt,
      ruleCodes: attempt.ruleCodes?.length ? attempt.ruleCodes : ["ABSENT"],
    })),
    pagination: formatPagination(data, requestedPage, perPage),
  };
}

export function formatCrmPetDiagnosisSummary(data = {}) {
  const byRule = Object.fromEntries(
    Object.entries(data.byRule || {}).map(([ruleCode, kpis]) => [
      ruleCode,
      formatCrmPetRecoveryKpis(kpis),
    ]),
  );

  return {
    opportunities: {
      asOf: data.opportunities?.asOf || null,
      byRule: Object.fromEntries(
        Object.entries(data.opportunities?.byRule || {}).map(([ruleCode, value]) => [
          ruleCode,
          toNumber(value),
        ]),
      ),
    },
    accumulated: formatCrmPetRecoveryKpis(data.accumulated),
    byRule,
  };
}

export function formatCrmPetEmployees(data) {
  return toArray(data)
    .map((employee) => ({
      id: employee.employeeId || employee._id || employee.id,
      name:
        employee.name?.full ||
        employee.name?.fullName ||
        employee.name ||
        employee.fullName ||
        employee.responsavelNome ||
        "Responsável sem nome",
    }))
    .filter((employee) => employee.id)
    .sort((first, second) =>
      String(first.name).localeCompare(String(second.name), "pt-BR"),
    );
}
